import React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {colors} from '../../colors/colors';
// @ts-expect-error
import {UpgradeArrowIcon} from '../../icon/svg/upgrade-arrow-icon';
import {Link} from '../../link/link';

type Props = {
    onClick?: () => void;
    variant?: 'upgrade' | 'licenses';
    text?: string;
    href?: string;
};

export function FeatureGateButton(props: Props) {
    const {variant = 'upgrade'} = props;

    let href;
    if (props.href) {
        href = props.href;
    } else {
        href = variant === 'upgrade' ? '/setup/billing/sales' : '/setup/user';
    }

    return (
        // @ts-expect-error
        <Link as={RoutedLink} size='big' variant='button-primary' to={href} onClick={props.onClick}>
            <div className='flex align-center gap-8'>
                {variant === 'upgrade' && (
                    <UpgradeArrowIcon size={12} wrapWithDiv={false} color={colors.blue} />
                )}
                {props.text || (variant === 'upgrade' ? 'Upgrade plan' : 'Assign licenses')}
            </div>
        </Link>
    );
}
